import { createContext, useContext, useState } from "react";
import { isValidPhoneNumber } from "react-phone-number-input";

const FormContext = createContext();

export function FormProvider({ children, type }) {
    const [formData, setFormData] = useState({
        senderEmail: '',
        receiverEmail: '',
        receiverNumber: '',
        senderNumber: '',
        ...(!type.includes('_door') ? { selectedLocker: null } : {}),
        ...(type.includes('_door') ? { province: null } : {}),
        ...(type.includes('_door') ? { entered_address: '', hasUserSelectPlace: false } : {}),
        parcelErrorMessage: '',
        parcelSizesLoading: false,
    });
   
    const [errors, setErrors] = useState({});

    // Validation rules
    const validateField = (name, value) => {
        // Skip validation for parcelErrorMessage and parcelSizesLoading
        if (name === 'parcelErrorMessage' || name === 'parcelSizesLoading') {
            return '';
        }
        let error = "";
        if (!value) {
            if (name === "senderEmail" || name === "senderNumber" || name === "receiverNumber" || name === "receiverEmail" || name === "selectedLocker" || name === "hasUserSelectPlace" || name === "entered_address"){
                if(name === "senderEmail"){
                    error = `Sender Email is required`;
                } else if (name === "senderNumber"){
                    error = `Sender Number is required`;
                } else if (name === "receiverEmail"){
                    error = `Receiver Email is required`;
                } else if (name === "receiverNumber"){
                    error = `Receiver Number is required`;
                } else if (name === "selectedLocker"){
                    error = `This field is required`;
                } else if (name === "hasUserSelectPlace"){
                    error = `You must select place from address field`;
                } else if (name === "entered_address"){
                    error = `Address is required`;
                }
            } else {
                error = `${name} is required`;
            }
        } else if (name === "senderEmail" && !/\S+@\S+\.\S+/.test(value)) {
            error = "Invalid email format";
        } else if (name === "receiverEmail" && !/\S+@\S+\.\S+/.test(value)) {
            error = "Invalid email format";
        } else if (name === "senderNumber"  && (!isValidPhoneNumber(value) || value.length !== 12)) {
            error = "Phone number is not valid";
        } else if (name === "receiverNumber" && (!isValidPhoneNumber(value) || value.length !== 12)) {
            error = "Phone number is not valid";
        } else if (name === "senderNumber" && value.length === 0) {
            error = "Phone number is required";
        } else if (name === "receiverNumber" && value.length === 0) {
            error = "Phone number is required ";
        }
        setErrors(prev => ({ ...prev, [name]: error }));
        return error;
    };

    const validateForm = () => {
        const newErrors = {};
        const isDoorType = type?.includes('_door');
        Object.keys(formData).forEach((name) => {
            const error = validateField(name, formData[name]);
            if (name === 'deliveryInstruction' || name === 'companyName') {
                return;
            }

            if (error) {
                newErrors[name] = error;
            }
            
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Returns true if no errors
    };

    const updateField = (name, value) => {
        setFormData(prev => ({ ...prev, [name]: value }));
        validateField(name, value);
    };

    return (
        <FormContext.Provider value={{ formData, errors, updateField,validateForm }}>
            {children}
        </FormContext.Provider>
    );
}

export function useForm() {
    return useContext(FormContext);
}
